module.exports = __webpack_public_path__ + "img/t_logo_1.670e47c7.png";